// extracted by mini-css-extract-plugin
export default {"pageLoader":"FullPageLoader_pageLoader__PbWn2"};